var _defs, _filter, _rect, _circle, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgBgP6B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "yellow"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5100"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "background_block",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 0,
    width: 100,
    height: 100,
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100,
    width: 100,
    height: 100,
    fill: "#ffd500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#000",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#000",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "objectBoundingBox"
  }, "x\n            ", /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000",
    stopOpacity: 0.4
  })))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "canvas"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "turbulence",
    baseFrequency: "0.1 0.66",
    numOctaves: 3,
    seed: 20,
    result: "n"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "n",
    result: "noise",
    mode: "multiply"
  }), /*#__PURE__*/React.createElement("feDiffuseLighting", {
    in: "n",
    result: "light",
    lightingColor: "#ff8000"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 45,
    elevation: 60,
    filtername: "feDistantLight"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff8000",
    width: 800,
    height: 800,
    filter: "url(#canvas)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 800,
    r: 910,
    fill: "url(#background)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    fill: "url(#background_block)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 100,100 100,125 200,125 200,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 100,100 100,125 200,125 200,100 ; M 100,100 100,100 200,100 200,100 ; M 100,100 100,125 200,125 200,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 100,100 100,200 125,200 125,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 100,100 100,200 125,200 125,100 ; M 100,100 100,200 100,200 100,100 ; M 100,100 100,200 125,200 125,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 190,100 200,100 200,200 190,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 190,100 200,100 200,200 190,200 ; M 200,100 200,100 200,200 200,200 ; M 190,100 200,100 200,200 190,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 100,300 100,325 200,325 200,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 100,300 100,325 200,325 200,300 ; M 100,300 100,300 200,300 200,300 ; M 100,300 100,325 200,325 200,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 100,300 100,400 125,400 125,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 100,300 100,400 125,400 125,300 ; M 100,300 100,400 100,400 100,300 ; M 100,300 100,400 125,400 125,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 190,300 200,300 200,400 190,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 190,300 200,300 200,400 190,400 ; M 200,300 200,300 200,400 200,400 ; M 190,300 200,300 200,400 190,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 300,300 300,325 400,325 400,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 300,300 300,325 400,325 400,300 ; M 300,300 300,300 400,300 400,300 ; M 300,300 300,325 400,325 400,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 300,300 300,400 325,400 325,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 300,300 300,400 325,400 325,300 ; M 300,300 300,400 300,400 300,300 ; M 300,300 300,400 325,400 325,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 390,300 400,300 400,400 390,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 390,300 400,300 400,400 390,400 ; M 400,300 400,300 400,400 400,400 ; M 390,300 400,300 400,400 390,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 300,700 300,725 400,725 400,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 300,700 300,725 400,725 400,700 ; M 300,700 300,700 400,700 400,700 ; M 300,700 300,725 400,725 400,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 300,700 300,800 325,800 325,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 300,700 300,800 325,800 325,700 ; M 300,700 300,800 300,800 300,700 ; M 300,700 300,800 325,800 325,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 390,700 400,700 400,800 390,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 390,700 400,700 400,800 390,800 ; M 400,700 400,700 400,800 400,800 ; M 390,700 400,700 400,800 390,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 500,100 500,125 600,125 600,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 500,100 500,125 600,125 600,100 ; M 500,100 500,100 600,100 600,100 ; M 500,100 500,125 600,125 600,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 500,100 500,200 525,200 525,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 500,100 500,200 525,200 525,100 ; M 500,100 500,200 500,200 500,100 ; M 500,100 500,200 525,200 525,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 590,100 600,100 600,200 590,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 590,100 600,100 600,200 590,200 ; M 600,100 600,100 600,200 600,200 ; M 590,100 600,100 600,200 590,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 500,500 500,525 600,525 600,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 500,500 500,525 600,525 600,500 ; M 500,500 500,500 600,500 600,500 ; M 500,500 500,525 600,525 600,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 500,500 500,600 525,600 525,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 500,500 500,600 525,600 525,500 ; M 500,500 500,600 500,600 500,500 ; M 500,500 500,600 525,600 525,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 590,500 600,500 600,600 590,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 590,500 600,500 600,600 590,600 ; M 600,500 600,500 600,600 600,600 ; M 590,500 600,500 600,600 590,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 700,300 700,325 800,325 800,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 700,300 700,325 800,325 800,300 ; M 700,300 700,300 800,300 800,300 ; M 700,300 700,325 800,325 800,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 700,300 700,400 725,400 725,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 700,300 700,400 725,400 725,300 ; M 700,300 700,400 700,400 700,300 ; M 700,300 700,400 725,400 725,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 790,300 800,300 800,400 790,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 790,300 800,300 800,400 790,400 ; M 800,300 800,300 800,400 800,400 ; M 790,300 800,300 800,400 790,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 700,700 700,725 800,725 800,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 700,700 700,725 800,725 800,700 ; M 700,700 700,700 800,700 800,700 ; M 700,700 700,725 800,725 800,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 700,700 700,800 725,800 725,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 700,700 700,800 725,800 725,700 ; M 700,700 700,800 700,800 700,700 ; M 700,700 700,800 725,800 725,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 790,700 800,700 800,800 790,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 790,700 800,700 800,800 790,800 ; M 800,700 800,700 800,800 800,800 ; M 790,700 800,700 800,800 790,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 0,0 0,25 100,25 100,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 0,0 0,25 100,25 100,0 ; M 0,0 0,0 100,0 100,0 ; M 0,0 0,25 100,25 100,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 0,0 0,100 25,100 25,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 0,0 0,100 25,100 25,0 ; M 0,0 0,100 0,100 0,0 ; M 0,0 0,100 25,100 25,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 90,0 100,0 100,100 90,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 90,0 100,0 100,100 90,100 ; M 100,0 100,0 100,100 100,100 ; M 90,0 100,0 100,100 90,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 0,200 0,225 100,225 100,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 0,200 0,225 100,225 100,200 ; M 0,200 0,200 100,200 100,200 ; M 0,200 0,225 100,225 100,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 0,200 0,300 25,300 25,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 0,200 0,300 25,300 25,200 ; M 0,200 0,300 0,300 0,200 ; M 0,200 0,300 25,300 25,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 90,200 100,200 100,300 90,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 90,200 100,200 100,300 90,300 ; M 100,200 100,200 100,300 100,300 ; M 90,200 100,200 100,300 90,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 0,400 0,425 100,425 100,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,400 0,425 100,425 100,400 ; M 0,400 0,400 100,400 100,400 ; M 0,400 0,425 100,425 100,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 0,400 0,500 25,500 25,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,400 0,500 25,500 25,400 ; M 0,400 0,500 0,500 0,400 ; M 0,400 0,500 25,500 25,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 90,400 100,400 100,500 90,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 90,400 100,400 100,500 90,500 ; M 100,400 100,400 100,500 100,500 ; M 90,400 100,400 100,500 90,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 0,600 0,625 100,625 100,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 0,600 0,625 100,625 100,600 ; M 0,600 0,600 100,600 100,600 ; M 0,600 0,625 100,625 100,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 0,600 0,700 25,700 25,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 0,600 0,700 25,700 25,600 ; M 0,600 0,700 0,700 0,600 ; M 0,600 0,700 25,700 25,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 90,600 100,600 100,700 90,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 90,600 100,600 100,700 90,700 ; M 100,600 100,600 100,700 100,700 ; M 90,600 100,600 100,700 90,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 200,0 200,25 300,25 300,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 200,0 200,25 300,25 300,0 ; M 200,0 200,0 300,0 300,0 ; M 200,0 200,25 300,25 300,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 200,0 200,100 225,100 225,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 200,0 200,100 225,100 225,0 ; M 200,0 200,100 200,100 200,0 ; M 200,0 200,100 225,100 225,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 290,0 300,0 300,100 290,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 290,0 300,0 300,100 290,100 ; M 300,0 300,0 300,100 300,100 ; M 290,0 300,0 300,100 290,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 200,200 200,225 300,225 300,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 200,200 200,225 300,225 300,200 ; M 200,200 200,200 300,200 300,200 ; M 200,200 200,225 300,225 300,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 200,200 200,300 225,300 225,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 200,200 200,300 225,300 225,200 ; M 200,200 200,300 200,300 200,200 ; M 200,200 200,300 225,300 225,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 290,200 300,200 300,300 290,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 290,200 300,200 300,300 290,300 ; M 300,200 300,200 300,300 300,300 ; M 290,200 300,200 300,300 290,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 200,400 200,425 300,425 300,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 200,400 200,425 300,425 300,400 ; M 200,400 200,400 300,400 300,400 ; M 200,400 200,425 300,425 300,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 200,400 200,500 225,500 225,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 200,400 200,500 225,500 225,400 ; M 200,400 200,500 200,500 200,400 ; M 200,400 200,500 225,500 225,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 290,400 300,400 300,500 290,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 290,400 300,400 300,500 290,500 ; M 300,400 300,400 300,500 300,500 ; M 290,400 300,400 300,500 290,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 400,0 400,25 500,25 500,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 400,0 400,25 500,25 500,0 ; M 400,0 400,0 500,0 500,0 ; M 400,0 400,25 500,25 500,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 400,0 400,100 425,100 425,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 400,0 400,100 425,100 425,0 ; M 400,0 400,100 400,100 400,0 ; M 400,0 400,100 425,100 425,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 490,0 500,0 500,100 490,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 490,0 500,0 500,100 490,100 ; M 500,0 500,0 500,100 500,100 ; M 490,0 500,0 500,100 490,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 400,600 400,625 500,625 500,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 400,600 400,625 500,625 500,600 ; M 400,600 400,600 500,600 500,600 ; M 400,600 400,625 500,625 500,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 400,600 400,700 425,700 425,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 400,600 400,700 425,700 425,600 ; M 400,600 400,700 400,700 400,600 ; M 400,600 400,700 425,700 425,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 490,600 500,600 500,700 490,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 490,600 500,600 500,700 490,700 ; M 500,600 500,600 500,700 500,700 ; M 490,600 500,600 500,700 490,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M 600,0 600,25 700,25 700,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 600,0 600,25 700,25 700,0 ; M 600,0 600,0 700,0 700,0 ; M 600,0 600,25 700,25 700,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M 600,0 600,100 625,100 625,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 600,0 600,100 625,100 625,0 ; M 600,0 600,100 600,100 600,0 ; M 600,0 600,100 625,100 625,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M 690,0 700,0 700,100 690,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 690,0 700,0 700,100 690,100 ; M 700,0 700,0 700,100 700,100 ; M 690,0 700,0 700,100 690,100 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBgP6B);
export default __webpack_public_path__ + "static/media/svg_bg_p6b.fd9ffb5d7168e2d162da1c4387e79c62.svg";
export { ForwardRef as ReactComponent };